export default __webpack_public_path__ + "static/media/thumb_HR_01.16b024a3.png";